module.exports = __webpack_public_path__ + "static/media/frames-24.bee4c26e.jpg";